var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLaporan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1H9.414C9.208 0.418 8.652 0 8 0C7.348 0 6.792 0.418 6.585 1H5.5C5.224 1 5 1.224 5 1.5V2.5C5 2.776 5.224 3 5.5 3H10.5C10.776 3 11 2.776 11 2.5V1.5C11 1.224 10.776 1 10.5 1Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H12V2.5C12 3.327 11.327 4 10.5 4H5.5C4.673 4 4 3.327 4 2.5V2H3C2.449 2 2 2.449 2 3V15C2 15.561 2.439 16 3 16H13C13.561 16 14 15.561 14 15V3C14 2.439 13.561 2 13 2ZM8.5 12.938V13.5C8.5 13.776 8.276 14 8 14C7.724 14 7.5 13.776 7.5 13.5V12.937C7.187 12.866 6.895 12.734 6.654 12.538C6.439 12.364 6.407 12.049 6.582 11.835C6.757 11.619 7.071 11.589 7.285 11.763C7.474 11.916 7.728 12 8 12C8.542 12 9 11.657 9 11.25C9 10.843 8.542 10.5 8 10.5C6.897 10.5 6 9.715 6 8.75C6 7.937 6.64 7.258 7.5 7.062V6.5C7.5 6.224 7.724 6 8 6C8.276 6 8.5 6.224 8.5 6.5V7.063C8.813 7.134 9.105 7.266 9.346 7.462C9.561 7.636 9.593 7.951 9.418 8.165C9.243 8.38 8.928 8.411 8.715 8.237C8.526 8.084 8.272 8 8 8C7.458 8 7 8.343 7 8.75C7 9.157 7.458 9.5 8 9.5C9.103 9.5 10 10.285 10 11.25C10 12.063 9.36 12.742 8.5 12.938Z",
    fill: "#8E8E8E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLaporan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/laporan.c40d97ed.svg";
export { ForwardRef as ReactComponent };